import { render } from "./MobileNavAndBasket.vue?vue&type=template&id=1ed9e1b7&scoped=true&class=busked"
import script from "./MobileNavAndBasket.vue?vue&type=script&lang=js"
export * from "./MobileNavAndBasket.vue?vue&type=script&lang=js"

import "./MobileNavAndBasket.vue?vue&type=style&index=0&id=1ed9e1b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed9e1b7"]])

export default __exports__